<section class="component-layer">
  <div
    class="header-container"
    style="
      margin-bottom: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    "
  >
    <div>
      <div style="display: flex; align-items: center; gap: 1rem">
        <h3 class="title m-0">Folio</h3>
      </div>
      <!-- <div style="display: flex; align-items: center; gap: 1rem">
        <h6 class="title m-0">Check availability and reservation overview</h6>
      </div> -->
    </div>
  </div>

  <!-- filters -->
  <div
    class="filter-room-table container-fluid"
    style="margin-bottom: 32px; padding: 0px"
  >
    <div class="flex-between-wrap">
      <div class="keyword-search">
        <p-iconfield iconPosition="left" class="ml-auto">
          <p-inputicon>
            <mat-icon>{{ commonService.getIcon("Search") }}</mat-icon>
          </p-inputicon>
          <input
            pInputText
            type="text"
            (input)="onGlobalSearchChange($event)"
            placeholder="Search folio"
            class="search-room-table table-filter"
            [(ngModel)]="globalSearchValue"
          />
        </p-iconfield>
      </div>

      <div class="d-flex justify-content-start">
        <div class="filter-group filter_status">
          <mat-icon class="filter_list_icon">
            {{ commonService.getIcon("Filter") }}
          </mat-icon>
          <p-select
            [options]="folioStatusOptions"
            [(ngModel)]="selectedStatus"
            (onChange)="onChangeFilter($event)"
            [showClear]="true"
            [checkmark]="true"
            placeholder="All Status"
            optionLabel="label"
            optionValue="value"
            class="w-full md:w-200 table-filter"
          >
            <!-- Selected item template -->
            <ng-template #selectedItem let-selectedOption>
              <div class="d-flex items-center gap-2" *ngIf="selectedOption">
                <div style="padding-left: 32px; margin-right: 10px">
                  {{ selectedOption.label }}
                </div>
              </div>
            </ng-template>

            <ng-template let-status #item>
              <div class="flex items-center gap-2">
                <div>{{ status.label }}</div>
              </div>
            </ng-template>
          </p-select>
        </div>
      </div>
    </div>

    <div
      class="d-flex filter-reset align-items-center mt-2"
      style="cursor: pointer"
      (click)="clear(dt2)"
    >
      <img
        src="/images/icons/rotate-clockwise.svg"
        alt="Reset"
        class="reset-icon"
      />
      <span
        class="d-md-block d-lg-block d-xl-block d-xxl-block"
        style="white-space: nowrap; color: #c40023; margin-left: 6px"
      >
        Reset Filter
      </span>
    </div>
  </div>

  <!-- table -->
  <section class="col-12">
    <p-table
      #dt2
      dataKey="id"
      [value]="data"
      [rows]="20"
      [paginator]="true"
      [rowsPerPageOptions]="[10, 15, 20, 30]"
      [lazy]="true"
      (onLazyLoad)="loadFolioPage($event)"
      [totalRecords]="totalRecords"
      [responsiveLayout]="'scroll'"
      [rowHover]="true"
      class="compact-table"
    >
      <ng-template pTemplate="header">
        <tr>
          <!-- <th style="width: 3em">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th> -->
          <th>Folio ID</th>
          <th>Guest Info</th>
          <th>Room</th>
          <th>Check In/Out</th>
          <th>Total Charges</th>
          <th>Payments</th>
          <th>Balance</th>
          <th>Status</th>
          <!-- <th>Credit Limit</th> -->

          <th
            class="text-center sticky-actions-column"
            style="text-align: right"
          >
            More
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data>
        <tr [pSelectableRow]="data">
          <!-- <td>
            <p-tableCheckbox [value]="data"></p-tableCheckbox>
          </td> -->

          <td (click)="goToDetails(data.folioId)">
            {{ data.folioNumber }}
          </td>
          <td>
            {{ data?.guestName ? data.guestName : "--" }}
          </td>

          <td>
            {{ data.roomNumbers ? data.roomNumbers : "--" }}
          </td>

          <td>
            <div style="display: flex; flex-direction: column">
              <span>
                {{
                  data?.charges?.rows?.length && data.charges.rows[0]?.checkIn
                    ? (data.charges.rows[0].checkIn | date: "dd MMM, yyyy")
                    : "--"
                }}
              </span>

              <span>
                {{
                  data?.charges?.rows?.[0]?.checkOut
                    ? (data.charges.rows[0].checkOut | date: "dd MMM, yyyy")
                    : "--"
                }}
              </span>
            </div>
          </td>

          <td>
            <div>{{ data.charges?.total }}</div>
          </td>
          <td>
            <div>{{ data.payments?.total }}</div>
          </td>
          <td>
            <div>{{ data.summary?.outstandingBalance }}</div>
          </td>

          <td>
            <div
              class="status-badge"
              [ngClass]="{
                closed: data.status === folioStatusEnum.VOID,
                open: data.status === folioStatusEnum.DRAFT,
                settled: data.status === folioStatusEnum.PAID,
                partial: data.status === folioStatusEnum.PARTIALLY_PAID,
              }"
            >
              <div style="font-size: 12px; line-height: 16px">
                {{ getFolioStatusLabel(data.status) }}
              </div>
            </div>
          </td>

          <!-- <td>
            <div class="engagement-percentage">
              <span>{{ data.engagement | numberFormat }}%</span>
            </div>
            <div class="progress-bar-container">
              <div
                class="progress-bar"
                [style.width.%]="data.engagement > 100 ? 100 : data.engagement"
                [ngStyle]="{
                  background: getEngagementColor(data.engagement),
                }"
              ></div>
            </div>
            <div class="credit">
              {{ data.CreditLimit }}
            </div>
          </td> -->

          <!-- <td
            class="text-center sticky-actions-column"
            style="text-align: right"
          >
            <div class="three-dot-icon">
            
             
            </div>
          </td> -->
          <td class="text-center sticky-actions-column">
            <button
              mat-icon-button
              [matMenuTriggerFor]="menu"
              class="more-vert-button"
              [class.menu-open]="menuTrigger.menuOpen"
              #menuTrigger="matMenuTrigger"
            >
              <mat-icon>{{ commonService.getIcon("Three_Dot") }}</mat-icon>
            </button>
            <mat-menu #menu="matMenu" class="simple-menu">
              <button mat-menu-item (click)="goToDetails(data.folioId)">
                <div class="view-mat-menu">
                  <img src="images/icons/view-details.svg" alt="" />
                  <span>View Details</span>
                </div>
              </button>
            </mat-menu>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </section>
</section>
